import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { actions as accountActions } from '../../reducers/Account';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import {
  accountSelector,
  isLoadingAccountSelector,
} from '../../selectors/Account';
import ReviewSignupHeader from '../../components/ReviewSignupHeader';
import ReviewerOnboarding from '../../components/ReviewerOnboarding';
import { Div } from 'Common/components/Atoms/Div';
import { Loading } from 'Common/components/Atoms/Loading';
import { Theme } from '@mui/material/styles';
import withTheme from '@mui/styles/withTheme';
import { User } from '../../models/User';

interface Props {
  user: User | null;
  fetchAccount: () => void;
  match: {
    path: string;
  };
  isLoadingUser: boolean;
  theme: Theme;
}

class ReviewerRoute extends Component<Props> {
  componentDidMount() {
    const { user, fetchAccount } = this.props;
    if (!user) {
      fetchAccount();
    }
  }

  render() {
    const { match, user, isLoadingUser } = this.props;
    return (
      <Div height="100vh">
        <ReviewSignupHeader />
        {!user && isLoadingUser && (
          <Loading size={64} mt={4} mx="auto" color="secondary" />
        )}
        {user && !user.is_reviewer && <Redirect to="/signups/reviewer" />}
        {user && (
          <Switch>
            <Route
              exact
              path={match.path}
              render={(props) => {
                return <ReviewerOnboarding {...this.props} {...props} />;
              }}
            />
          </Switch>
        )}
      </Div>
    );
  }
}

function mapStateToProps(state: any) {
  const account = accountSelector(state);
  const isLoadingUser = isLoadingAccountSelector(state);

  return {
    user: account.user,
    isLoadingUser,
  };
}

function mapDispatchToProps(dispatch: Dispatch<{}>) {
  return bindActionCreators(accountActions, dispatch);
}

export default withTheme(
  connect(mapStateToProps, mapDispatchToProps)(ReviewerRoute)
);
